import "./texte.css"
import Accordeon from "../Accordeon/accordeon"
import texte from "../../data/texte.json"
import Back from "../../components/Back/back";
import back from "../../assets/back.png"

function Texte (){
return (
<div className="service-contenant">
<Back title="Bienvenue chez Laulie Web" image={back}/>
    <div className="service-entete">
        <p>Votre partenaire numérique pour propulser votre présence en ligne vers de nouveaux
        sommets.<br></br> Je suis passionnée et dévouée, spécialisée dans la création de sites web sur mesure,<br></br> le développement
        d'e-commerce et l'optimisation de la visibilité en ligne.
        </p>
    </div>
    <div className="service-accordeon-contenant">
        {
            texte.map((product)=>{
                return(
                    <div className="service-accordeon">
                    <Accordeon title={product.titre} content={product.description}>
                    </Accordeon>
                  </div>
                )
            })
        }
          </div>
</div>
)
}
export default Texte